import { Button, IconButton, withStyles } from "@material-ui/core";

export const StyledButton = withStyles((theme) => ({
    root: {
      boxShadow: "none",
    },
    label: {
        textTransform: "capitalize"
    }
  }))(Button);

  export const StyledIconButton = withStyles((theme) => ({
    root: {
      boxShadow: "none",
    },
    label: {
        textTransform: "capitalize"
    }
  }))(IconButton);